/** "About 20 million": a country's population, rounded for reading. No locale: matches PopulationText.swift. */
export function populationText(n: number): string {
  const oneDecimal = (x: number): string => { const r = Math.round(x * 10) / 10; return Number.isInteger(r) ? String(r) : r.toFixed(1); };
  const grouped = (x: number): string => String(x).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (Math.round(n / 1e8) >= 10) return `About ${oneDecimal(n / 1e9)} billion`;
  if (n >= 9_950_000) return `About ${Math.round(n / 1e6)} million`;
  if (Math.round(n / 1e5) >= 10) return `About ${oneDecimal(n / 1e6)} million`;
  if (n >= 10_000) return `About ${grouped(Math.round(n / 1000) * 1000)}`;
  if (n >= 1_000) return `About ${grouped(Math.round(n / 100) * 100)}`;
  return `About ${Math.max(10, Math.round(n / 10) * 10)}`;
}
